// Focus/blur handlers for TaskListBase container
import { useCallback } from 'react';

export function useTaskListFocusHandlers(taskListRef, setIsFocused) {
  const handleFocus = useCallback(() => setIsFocused(true), [setIsFocused]);

  const handleBlur = useCallback(
    (e) => {
      if (!taskListRef.current?.contains(e.relatedTarget)) setIsFocused(false);
    },
    [taskListRef, setIsFocused],
  );

  return { handleFocus, handleBlur };
}
